import React, { useEffect, useRef } from 'react';

export default function Size1(props) {
  const { getSize, setSize, location, label, sizes, isWomens } = props;
  const ref = useRef(null);

  let useSmallerSize = true;
  if (location.code === 'eu' && isWomens) {
    useSmallerSize = false;
  }

  useEffect(() => {
    if (ref.current) {
      if (!getSize.us) {
        ref.current.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []);

  return (
    <fieldset className="form-field" ref={ref}>
      <legend className="form-legend">{label}</legend>
      <div className="option-values">
        {sizes
          .map(function (size, index) {
            if (!size.presented || this.includes(size[location.code]) === useSmallerSize) {
              this.push(size[location.code])
              return (null);
            }
            this.push(size[location.code])
            return (
              <div key={index} className="option-value">
                <input
                  type="radio"
                  className="option-value-input"
                  id={`sneakerSize-${index}`}
                  name="sneakerSize"
                  value={size.us}
                  checked={getSize.us === size.us}
                  onChange={() => setSize(size)} />
                <label htmlFor={`sneakerSize-${index}`} className="option-value-name">{size[location.code]}</label>
              </div>
            )
          }, [])
        }
      </div>
    </fieldset>
  );
}